import React from "react"

function FeatureD() {
  return (
    <svg viewBox="0 0 266 150" fill="none">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <rect
        x={20.5}
        y={54.5}
        width={107}
        height={41}
        rx={1.5}
        fill="var(--solid)"
        stroke="var(--base-400)"
      />
      <circle cx={32} cy={68} r={6} fill="var(--main-200)" />
      <path
        d="M44 72.5a1.5 1.5 0 011.5-1.5h68a1.5 1.5 0 010 3h-68a1.5 1.5 0 01-1.5-1.5zM44 79.5a1.5 1.5 0 011.5-1.5h54a1.5 1.5 0 010 3h-54a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--base-500)"
      />
      <path
        d="M44 86.5a1.5 1.5 0 011.5-1.5h19a1.5 1.5 0 010 3h-19a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--main-500)"
      />
      <rect
        x={44}
        y={62}
        width={32}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
      <rect
        x={138.5}
        y={54.5}
        width={107}
        height={41}
        rx={1.5}
        fill="var(--solid)"
        stroke="var(--base-400)"
      />
      <circle cx={150} cy={68} r={6} fill="var(--main-200)" />
      <path
        d="M162 72.5a1.5 1.5 0 011.5-1.5h68a1.5 1.5 0 010 3h-68a1.5 1.5 0 01-1.5-1.5zM162 79.5a1.5 1.5 0 011.5-1.5h54a1.5 1.5 0 010 3h-54a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--base-500)"
      />
      <path
        d="M162 86.5a1.5 1.5 0 011.5-1.5h19a1.5 1.5 0 010 3h-19a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--main-500)"
      />
      <rect
        x={162}
        y={62}
        width={32}
        height={4}
        rx={2}
        fill="var(--solid-900)"
      />
    </svg>
  )
}

export default FeatureD;
